<template>

  <div class="infinite-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy"
    style="overflow:auto;bodrer:1px solid #e43" infinite-scroll-distance="1">

    <div class="qinsao-wrap">
      <div class="qinsao-div" v-if="lists.length>0" @click="openlist()">
        <img class="qinsao" src="/static/images/qingsao.png" alt="">
        <div class="qinsao-text">清除记录</div>
      </div>
    </div>
    <el-card class="box-card item" v-for="(item,index) in lists" :key="index">
      <!-- s2 -->
      <div class="ah-tab-content-wrapper">
        <div class="ah-tab-content ">
          <!-- 单个order-list -->
          <div class="order-list">
            <div class="order-cell weui-cell">
              <div class="order-num">
                <span decode="true">
                  订&ensp;单&ensp;号：
                </span>
              </div>
              <div class="order-num-info">{{item.order_sn}}</div>
              <button @click="doCopy(item.order_sn)" class="order-copy">复制</button>
            </div>
            <div class="order-des weui-line ">
              <div class="order-info ">
                <div class="weui-cell order-cell">
                  <div class="order-status">订单状态：</div>
                  <div class="order-status-content">{{item.statusinfo}}</div>
                </div>
                <div class="weui-cell order-cell">
                  <div class="order-num">手机号码：</div>
                  <div>{{item.phone}}</div>
                </div>
                <div class="weui-cell order-cell ">
                  <div class="order-num">订单金额：</div>
                  <div>PHP{{item.price}}</div>
                </div>
                <div class="weui-cell  order-cell ">
                  <div class="order-num">订单时间：</div>
                  <div>{{item.pay_time}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- e -->
      </div>
    </el-card>

    <p v-show="droping">加载中...</p>
    <p v-show="noMore" style="margin-bottom: 100px;">没有更多了</p>

    <navBar :idx="1"></navBar>
  </div>

</template>

<script>
  // 导入组件
  import navBar from '@/components/navBar';
  export default {
    name: 'historycard',
    // 组件注册
    components: {
      navBar
    },
    data() {
      return {
        busy: false,
        droping: false,
        noMore: false,
        lists: [],
        page: 0,
        pageSize: 10,
      }
    },
    mounted() {
      let auth_token = localStorage.getItem('auth_token');
      if (!auth_token) {
        this.$message({
          message: "请先登录！",
          type: "warning",
        })
        setTimeout(() => {
          this.$router.push('/');
        }, 2000);
      }
    },
    methods: {
      openlist() {
        this.$confirm('此操作将删除您的全部充值记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api
            .request('Order/del', {})
            .then(({ data }) => {
              this.$message({
                message: data.msg,
                type: "warning"
              })
            })
            .catch(error => {
              this.$message({
                message: "删除失败！",
                type: "warning"
              })
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      doCopy(msg){
          this.$copyText(msg).then((e) => {
            this.$message({
              type: 'success',
              message: '复制成功！'
            });
          }, (e) => {
            this.$message({
              type: 'warning',
              message: '复制失败！'
            });
          })
      },
      loadMore() {
        this.busy = true;
        this.droping = true;
        let auth_token = localStorage.getItem('auth_token');
        if (auth_token) {
          this.page++;
          this.$api
            .request('Order/lists', {page: this.page, pageSize: this.pageSize})
            .then(({ data }) => {
              if (data.length <= 0 || data.length < this.pageSize) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
              data.forEach(item => {
                this.lists.push(item);
              });
              this.busy = false;
              this.droping = false;
            })
            .catch(error => {
              this.$message({
                message: error + "加载充值记录失败！",
                type: "warning"
              })
            });
        } else {
          this.busy = false;
          this.droping = false;
          this.noMore = true;
        }
      }
    }
  }
</script>

<style scoped>
  .text {
    font-size: 28rpx;
  }

  .box-card {
    margin-bottom: 5px;
  }

  .order-list>div.order-cell:first-child {
    font-weight: 700;
  }

  .order-list {
    margin-bottom: 10rpx;
    border-radius: 30rpx;
    padding: 20rpx;
    background-color: #fff;
    overflow: hidden;
    margin-top: 20rpx;
  }

  .order-info {
    font-weight: 400;
    color: #999
  }

  .order-des {
    position: relative
  }

  .weui-cell {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    font-weight: 400;
    position: relative
  }

  .order-cell .order-num {
    padding-left: 0;
    text-align: justify;
    font-size: 28rpx;
  }

  .order-cell .order-copy {
    position: absolute;
    right: 5px;
    color: dimgray;
    border-color: dimgray;
    border-radius: 5px;
  }

  .order-cell .order-status {
    color: #e4393c;
    padding-left: 0;
    text-align: justify;
    font-size: 28rpx;
  }

  .order-cell .order-status-content {
    color: #e4393c;
  }

  .order-cell .order-type {
    color: #e4393c;
    font-size: 14px;
    position: absolute;
    right: 5px;
  }

  .order-cell .order-num-info {
    text-align: left;
    font-size: 28rpx;
    line-height: 1.5;
    overflow: hidden;
    width: 60%;
    text-overflow: ellipsis;
    margin-left: 20rpx;
  }

  .empty {
    padding: 60rpx 20rpx;
    margin: 0 auto;
    text-align: center
  }

  .empty:after {
    content: "'没有更多内容'";
    text-align: center;
    color: #e43;
    font-size: inherit;
    font-size: .186667rem
  }

  .infinite-list {
    position: relative;
  }

  .btn {
    width: 50%;
    padding: 15px;
    font-size: 16px;
  }

.qinsao-wrap{
  top: 60%;
  max-width: 750px;
  position: fixed;
  width: 100%;
  /* bottom: 150px; */
}
  .qinsao-div {
    margin-right:15px;
    float: right;
    width: 60px;
    height: 60px;
    z-index: 9;
    display: flex;
    flex-direction: column;
    /* justify-content: center; */
    align-items: center;
    /* border: 1px solid #888888; */
    border-radius: 50px;
  }

  .qinsao {
    width: 40px;
    height: 40px;
  }

  .qinsao-text {
    font-size: 12px;
    color: #888888;
  }

  .delete_wrap {
    position: fixed;
    top: 60%;
    width: 100%;
    max-width: 750px;
  }

  .delete {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    float: right;
  }

  .delete_wrap img {
    width: 40px;
    height: 40px;
    object-fit: cover;
  }

  .delete_text {
    color: 12px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/page/historycard.vue